import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Bonlivraison from '@/features/bon-livraison'

export const Route = createFileRoute('/_authenticated/bon-livraison/')({
  component: Bonlivraison,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Bon Livraison`,
      },
    ],
  }),
})
